module.exports = __webpack_public_path__ + "img/chara02.5d8a015a.png";